import { IDs } from '../../helpers/IDs';

export function getUmrechungsFaktor(
    data: any, kennzahl_kuerzel: string, jahr: number, field?: string, callback?: (data: any) => void
): any {
    // console.log('DATA', data);
    const heizwerte = data[IDs.ENT_PARAMETER_HEIZWERTE] || [];
    const kennzahlen_def = data[IDs.ENT_KENNZAHLEN_DEFINTION];

    if (!kennzahlen_def) {
        return 1;
    }
    // Hinweis: Die Kennzahlen-Definition enthalten hier nur noch die Kennzahlen für "unser" Gewerk
    // Die Filterung erfolgt bereits im Loader

    // Kennzahl finden
    const kennzahl = kennzahlen_def.find((kd: any) => kd.kuerzel === kennzahl_kuerzel);

    if ((!kennzahl || !kennzahl.umrechnung) && !field) {
        return 1;
    }
    const fieldName = field ? field : kennzahl.umrechnung_co2;
    heizwerte.sort((a: any, b: any) => a.jahr - b.jahr);

    // Jahr bzw. Werte finden
    let rowFound: any = undefined;
    heizwerte.forEach((row: any) => {
        // Wenn wir noch keine Row gefunden haben, nehmen wir die
        if (!rowFound) {
            rowFound = row;
            return;
        }
        // Wir hatten schonmal eine row gefunden
        if (rowFound.jahr > jahr && row.jahr <= jahr) {
            // Diese war größer als das Jahr, wir suchen aber eigentlich das Jahr, das gleich oder kleiner ist
            rowFound = row;
            return;
        }
        // Wir hatten schonmal eine Row, die gleich oder kleiner war
        if (rowFound.jahr < jahr && row.jahr <= jahr && row.jahr > rowFound.jahr) {
            rowFound = row; // Dieses Jahr ist besser
            return;
        }
    });
    if (!rowFound) {
        return 1;
    }
    if (typeof callback === 'function') {
        // console.log('Umrechnung', jahr, kennzahl_kuerzel, rowFound);
        callback(rowFound);
    }
    return rowFound[fieldName];
}
